var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationsVx = function SvgNotificationsVx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18.646 4.064a.998.998 0 0 1 1.148.328 1.005 1.005 0 0 1 .142.962l-5.993 16.979a1 1 0 0 1-1.85.09l-3.345-7.17-7.17-3.347a1 1 0 0 1 .09-1.85l16.978-5.992zm-7.944 10.648l2.17 4.648L16.59 8.824l-5.888 5.888zm-1.414-1.414l5.888-5.888L4.64 11.13l4.648 2.169z"
  })));
};
export default SvgNotificationsVx;